export default "__VITE_ASSET__D7QXhd4w__"